export default __webpack_public_path__ + "static/media/Download.a2978ccc.svg";